/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Cервис-адаптер вокруг Lego API экосистемы РТК
 */

/**
 * Cервис-адаптер вокруг Lego API экосистемы РТК
 */
export class LegoAdapterServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод проверки услуги.
   * Возвращает true если хотя бы у одного аккаунта на квартире есть нужный сервис и он содержит активный компонент.
   * Метод доступен для: admin, service
   */
  GetLegoAdapterServiceCheck = (req: GetLegoAdapterServiceCheckRequestDto, init?: RequestInit): Promise<GetLegoAdapterServiceCheckResponseDto> => {
    return fm.request<GetLegoAdapterServiceCheckRequestDto, GetLegoAdapterServiceCheckResponseDto>(`${this.host}/ecosystem/api/v1/lego_adapter/service/check/${encodeURIComponent(req.orpon)}/${encodeURIComponent(req.roomNumber)}/${encodeURIComponent(req.serviceType)}${fm.buildQuery(req, ["orpon","roomNumber","serviceType"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип услуги
 */
export enum ServiceType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Cотовая связь
   */
  SOTOVAYA_SVYAZ_MVNO = "SOTOVAYA_SVYAZ_MVNO",
  /**
   * Цифровое интерактивное ТВ
   */
  IPTV = "IPTV",
  /**
   * Домашний интернет
   */
  SHPD = "SHPD",
  /**
   * Кабельное цифровое ТВ
   */
  KABELNOE_TV = "KABELNOE_TV",
  /**
   * Стационарный телефон
   */
  FIKSIROVANNAYA_SVYAZ = "FIKSIROVANNAYA_SVYAZ",
  /**
   * Лицей
   */
  ROSTELECOM_LYCEUM = "ROSTELECOM_LYCEUM",
  /**
   * Умный дом
   */
  SMART_HOUSE = "SMART_HOUSE",
  /**
   * Юрист
   */
  JURIST = "JURIST",
  /**
   * WINK ТВ
   */
  WINK = "WINK",
  /**
   * Оборудование
   */
  SALE_EQUIPMENT = "SALE_EQUIPMENT",
  /**
   * Ключ
   */
  SMART_INTERCOM = "SMART_INTERCOM",
  /**
   * Шлагбаум
   */
  SMART_BARRIER = "SMART_BARRIER",
  /**
   * Гарантия плюс
   */
  WARRANTY_PLUS = "WARRANTY_PLUS",
  /**
   * Аналоговое цифровое ТВ
   */
  ANALOG_CABLE_TV = "ANALOG_CABLE_TV",
  /**
   * АЛЛЁ
   */
  OTT_PERSON = "OTT_PERSON",
  /**
   * Беспроводной интернет
   */
  WIFI = "WIFI",
}
/**
 * Тип услуги
 */
export type ServiceTypeResponseEnum = keyof typeof ServiceType
/**
 * Тип услуги
 */
export type ServiceTypeRequestEnum = Exclude<ServiceTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Запрос проверки услуги на квартире
 */
export type GetLegoAdapterServiceCheckRequestDto = {
  /**
   * ОРПОН.
   * Идентификатор дома.
   * # Диапазон: 0..9223372036854775807
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Паттерн: /^[0-9]{1,4}$/
   */
  roomNumber: string
  /**
   * Тип услуги
   */
  serviceType: ServiceTypeRequestEnum
}
/**
 * Результат запроса метода проверки услуги на квартире
 */
export type GetLegoAdapterServiceCheckResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Наличие активной услуги на квартире
   */
  readonly data: boolean
  /**
   * Ошибка
   */
  readonly error: GetLegoAdapterServiceCheckResponseErrorDto
}>
/**
 * Ошибка запроса метода проверки услуги на квартире
 */
export type GetLegoAdapterServiceCheckResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации запроса информации об услугах пользователя
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка запроса к API экосистемы
   */
  readonly ecosystemApiError: GetLegoAdapterServiceCheckResponseErrorEcosystemApiErrorRequestDto
}>
/**
 * Ошибка запроса метода проверки услуги на квартире
 */
export type GetLegoAdapterServiceCheckResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации запроса информации об услугах пользователя
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка запроса к API экосистемы
   */
  readonly ecosystemApiError: GetLegoAdapterServiceCheckResponseErrorEcosystemApiErrorDto
}>
/**
 * Ошибка запроса к API экосистемы
 */
export type GetLegoAdapterServiceCheckResponseErrorEcosystemApiErrorRequestDto = {
}
/**
 * Ошибка запроса к API экосистемы
 */
export type GetLegoAdapterServiceCheckResponseErrorEcosystemApiErrorDto = {
}
/**
 * Услуга
 */
export type ServiceRequestDto = {
}
/**
 * Услуга
 */
export type ServiceResponseDto = {
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос проверки услуги на квартире
   */
  "GetLegoAdapterServiceCheckRequest": {
    "kind": "class",
    "text": "Запрос проверки услуги на квартире",
    "fields": {
      /**
       * ОРПОН.
       * Идентификатор дома.
       * # Диапазон: 0..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\nИдентификатор дома.\n# Диапазон: 0..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 9223372036854775807,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9223372036854775807"
          },
        }
      },
      /**
       * Номер квартиры.
       * # Паттерн: /^[0-9]{1,4}$/
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры.\n# Паттерн: /^[0-9]{1,4}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^[0-9]{1,4}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[0-9]{1,4}$/"
          }
        }
      },
      /**
       * Тип услуги
       */
      "serviceType": {
        "type": "Service.Type",
        "text": "Тип услуги",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Результат запроса метода проверки услуги на квартире
   */
  "GetLegoAdapterServiceCheckResponse": {
    "kind": "class",
    "text": "Результат запроса метода проверки услуги на квартире",
    "fields": {
      /**
       * Наличие активной услуги на квартире
       */
      "data": {
        "type": "bool",
        "text": "Наличие активной услуги на квартире",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetLegoAdapterServiceCheckResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса метода проверки услуги на квартире
   */
  "GetLegoAdapterServiceCheckResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса метода проверки услуги на квартире",
    "fields": {
      /**
       * Ошибка валидации запроса информации об услугах пользователя
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации запроса информации об услугах пользователя",
      },
      /**
       * Ошибка запроса к API экосистемы
       */
      "ecosystemApiError": {
        "type": "GetLegoAdapterServiceCheckResponse.Error.EcosystemApiError",
        "text": "Ошибка запроса к API экосистемы",
      },
    },
  },
  /**
   * Ошибка запроса к API экосистемы
   */
  "GetLegoAdapterServiceCheckResponse.Error.EcosystemApiError": {
    "kind": "class",
    "text": "Ошибка запроса к API экосистемы",
  },
  /**
   * Услуга
   */
  "Service": {
    "kind": "class",
    "text": "Услуга",
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Тип услуги
   */
  "Service.Type": {
    "kind": "enum",
    "text": "Тип услуги",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Cотовая связь
       */
      "SOTOVAYA_SVYAZ_MVNO": {
        "i": 1,
        "text": "Cотовая связь",
      },
      /**
       * Цифровое интерактивное ТВ
       */
      "IPTV": {
        "i": 2,
        "text": "Цифровое интерактивное ТВ",
      },
      /**
       * Домашний интернет
       */
      "SHPD": {
        "i": 3,
        "text": "Домашний интернет",
      },
      /**
       * Кабельное цифровое ТВ
       */
      "KABELNOE_TV": {
        "i": 4,
        "text": "Кабельное цифровое ТВ",
      },
      /**
       * Стационарный телефон
       */
      "FIKSIROVANNAYA_SVYAZ": {
        "i": 5,
        "text": "Стационарный телефон",
      },
      /**
       * Лицей
       */
      "ROSTELECOM_LYCEUM": {
        "i": 6,
        "text": "Лицей",
      },
      /**
       * Умный дом
       */
      "SMART_HOUSE": {
        "i": 7,
        "text": "Умный дом",
      },
      /**
       * Юрист
       */
      "JURIST": {
        "i": 8,
        "text": "Юрист",
      },
      /**
       * WINK ТВ
       */
      "WINK": {
        "i": 9,
        "text": "WINK ТВ",
      },
      /**
       * Оборудование
       */
      "SALE_EQUIPMENT": {
        "i": 10,
        "text": "Оборудование",
      },
      /**
       * Ключ
       */
      "SMART_INTERCOM": {
        "i": 11,
        "text": "Ключ",
      },
      /**
       * Шлагбаум
       */
      "SMART_BARRIER": {
        "i": 12,
        "text": "Шлагбаум",
      },
      /**
       * Гарантия плюс
       */
      "WARRANTY_PLUS": {
        "i": 13,
        "text": "Гарантия плюс",
      },
      /**
       * Аналоговое цифровое ТВ
       */
      "ANALOG_CABLE_TV": {
        "i": 14,
        "text": "Аналоговое цифровое ТВ",
      },
      /**
       * АЛЛЁ
       */
      "OTT_PERSON": {
        "i": 15,
        "text": "АЛЛЁ",
      },
      /**
       * Беспроводной интернет
       */
      "WIFI": {
        "i": 16,
        "text": "Беспроводной интернет",
      },
    },
  },
}